import React from 'react';
import { useTranslation } from 'react-i18next';
import logoicon from '../images/tuutuum-logo-icon.png';
import LanguageSwitcher from '../components/LanguageSwitcher';

const CreateBearerStep5_BloodType = ({onNext, onPrevious, bloodType, setBloodType, isLoading}) => {
	const { t } = useTranslation();

	return (<>
		<div className="flex items-center justify-center h-full w-full bg-gradient-to-r from-cyan-100 to-green-100">
			<div className="flex flex-col neumorp items-center justify-center space-y-5 bg-white px-6 py-10 sm:p-10 rounded-lg shadow-lg w-full max-w-2xl">
				{/* Logo and Language Switcher */}
				<div className="flex items-center justify-between w-full">
					<img src={logoicon} alt="Tuutuum Logo" className="block h-7 w-auto"/>
					<LanguageSwitcher />
				</div>
				
				<div className="text-center px-2">
					<h2 className="text-2xl leading-tight mb-1">
					{t("blood_type_question")}
					</h2>
					<p className="text-base text-gray-600 mt-1">
						{t("can_update_anytime")}
					</p>
				</div>

				{/* Blood Type select */}
				<div className="w-full">
					<label htmlFor="bloodType" className="block text-sm font-medium leading-6 text-gray-900 mb-2">
						{t("blood_type")}
					</label>
					<select
						id="bloodType"
						value={bloodType}
						onChange={(e) => setBloodType(e.target.value)}
						className="block w-full rounded-md border-0 py-3 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-cyan-600 sm:text-sm sm:leading-6"
					>
						<option value="unspecified">{t("blood_type_unspecified")}</option>
						<option value="A+">A+</option>
						<option value="A-">A-</option>
						<option value="B+">B+</option>
						<option value="B-">B-</option>
						<option value="AB+">AB+</option>
						<option value="AB-">AB-</option>
						<option value="O+">O+</option>
						<option value="O-">O-</option>
					</select>
				</div>

				<div className="flex flex-nowrap w-full gap-4 justify-between pt-4">
					{/* Previous Button */}
					<button
						onClick={onPrevious}
						disabled={isLoading}
						className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
					>
						{t("previous")}
					</button>
					{/* Done Button */}
					<button
						onClick={onNext}
						disabled={isLoading}
						className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
					>
						{isLoading ? t("saving") + "..." : t("done")}
					</button>
				</div>
			</div>
		</div>
	</>);
}

export default CreateBearerStep5_BloodType;
